import React from "react";
import LoadingStates from "../../constants/states/LoadingStates";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ActiveAdvertisementReservationsTableView from "../views/ActiveAdvertisementReservationsTableView";
import ReservationHistoryTableView from "../views/ReservationHistoryTableView";
import AdvertisementReservationStore from "../../stores/AdvertisementReservationStore";
import PendingReservationsTableView from "../views/PendingReservationsTableView";
import LoadingView from "../views/LoadingView";


class AdvertisementReservationsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "advertisementReservationStore": AdvertisementReservationStore.getState(),
        };
    }

    componentDidMount() {
        this.spaceReservationStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_RESERVATIONS_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GET_MEMBER_ADVERTISEMENTS_RESERVATIONS, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.spaceReservationStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_RESERVATIONS_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementReservationStore": AdvertisementReservationStore.getState(),
        });
    };

    render() {
        if (this.state.advertisementReservationStore.loadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Advertisement Reservation"/>
            );
        }

        const hash = this._getHashOrDefault();


        return (
            <div className="container mt-13vh">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="nav nav-tabs card-header-tabs" id="bologna-list" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#reservation-requests") ? "btn nav-link active": "btn nav-link"}
                                                    id="reservation-requests-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#reservation-requests")}
                                                    role="tab"
                                                    aria-controls="reservation-requests-tab"
                                                    aria-selected="true"
                                                >
                                                    Reservation Requests
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#active-reservations") ? "btn nav-link active": "btn nav-link"}
                                                    id="active-reservations-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#active-reservations")}
                                                    role="tab"
                                                    aria-controls="active-reservations"
                                                    aria-selected="false"
                                                >
                                                    Upcoming & Active Reservations
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#history") ? "btn nav-link active": "btn nav-link"}
                                                    id="history-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#history")}
                                                    role="tab"
                                                    aria-controls="history-tab"
                                                    aria-selected="false"
                                                >
                                                    History
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">Advertisement Reservation Management</h4>

                                <div className="tab-content mt-3">
                                    <div className={(hash === "#reservation-requests") ? "tab-pane active": "tab-pane fade"} id="reservation-requests" role="tabpanel" aria-labelledby="reservation-requests-tab">
                                        {<PendingReservationsTableView reservations={this.state.advertisementReservationStore.reservationRequests}/>}
                                    </div>
                                    <div className={(hash === "#active-reservations") ? "tab-pane active": "tab-pane fade"} id="active-reservations" role="tabpanel" aria-labelledby="active-reservations-tab">
                                        {<ActiveAdvertisementReservationsTableView reservations={this.state.advertisementReservationStore.activeReservations}/>}
                                    </div>
                                    <div className={(hash === "#history") ? "tab-pane active": "tab-pane fade"} id="unlisted-spaces" role="tabpanel" aria-labelledby="history-tab">
                                        {<ReservationHistoryTableView reservations={this.state.advertisementReservationStore.history}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _changeHashTo(event, newHash) {
        event.stopPropagation();
        window.location.hash = newHash;
    }

    _getHashOrDefault() {
        const hash = window.location.hash;
        if (hash === "#active-reservations") {
            return hash;
        }
        if (hash === "#history") {
            return hash;
        }
        return "#reservation-requests";
    }
}

export default AdvertisementReservationsContainer;